import { Component, OnInit } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';

import { PatientData } from './components/types/patient-data';
import { PatientService } from './services/patient.service';
import {ToastService} from "./components/custom/messaging/toast/toast.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private adminTest = /^\/admin\//;

  currentPatient: PatientData;
  adminPage = false;

  constructor(private router: Router, private patient: PatientService, private toast: ToastService) {}

  ngOnInit(): void {
    this.currentPatient = this.patient.currentPatient;
    this.patient.patientChanged$.subscribe(
      patient => {
        this.currentPatient = patient;
        if (!this.currentPatient) {
          this.toast.removeAll();
        }
      }
    );
    this.router.events.subscribe(event => {
      if (event instanceof RouterEvent) {
        this.adminPage = this.adminTest.test(event.url);
      }
    });
  }
}
